const locale = {
	// #region ERP Orders fields
	DETAILS_ERP_ORDERS_FIELD_CODE: 'Codice NAV',
	DETAILS_ERP_ORDERS_FIELD_DATE_ORDER: 'Data ordine',
	DETAILS_ERP_ORDERS_FIELD_DATE_DATE_REQDELIVERY: 'Data consegna richiesta',
	DETAILS_ERP_ORDERS_FIELD_DATE_DATE_PROMDELIVERY: 'Data consegna promessa',
	DETAILS_ERP_ORDERS_FIELD_COMPANY: 'Cliente',
	DETAILS_ERP_ORDERS_FIELD_BILL_COMPANY: 'Azienda a cui fatturare',
	DETAILS_ERP_ORDERS_FIELD_SALESPERSON: 'Utente assegnato esterno',
	DETAILS_ERP_ORDERS_FIELD_SHIPPING_METHOD: 'Metodo di spedizione',
	DETAILS_ERP_ORDERS_FIELD_SHIPPING_AGENT: 'Spedizioniere',
	DETAILS_ERP_ORDERS_FIELD_PRICING_GROUP: 'Gruppo prezzi',
	DETAILS_ERP_ORDERS_FIELD_DISCOUNT_GROUP: 'Gruppo sconto',
	DETAILS_ERP_ORDERS_FIELD_PAYMENT_TERMS: 'Termini di pagamento',
	DETAILS_ERP_ORDERS_FIELD_PAYMENT_METHOD: 'Metodo di pagamento',
	DETAILS_ERP_ORDERS_FIELD_EXTERNAL_NUMBER: 'Riferimento esterno',
	DETAILS_ERP_ORDERS_FIELD_TOT_TAX_EXCL: 'Totale (tasse escluse)',
	DETAILS_ERP_ORDERS_FIELD_TOT_TAX_INCL: 'Totale (tasse incluse)',
	// #endregion

	// #region ERP Orders Lines
	DETAILS_ERP_ORDERS_LINES_FIELD_ERP_ID: 'Codice NAV',
	DETAILS_ERP_ORDERS_LINES_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM: 'Prodotto',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM_SERIES: 'Serie',
	DETAILS_ERP_ORDERS_LINES_FIELD_ITEM_MEASURES: 'Misure',
	DETAILS_ERP_ORDERS_LINES_FIELD_BASE_PRICE: 'Prezzo base',
	DETAILS_ERP_ORDERS_LINES_FIELD_DISCOUNT: 'Sconto',
	DETAILS_ERP_ORDERS_LINES_FIELD_UNIT_PRICE: 'Prezzo unitario',
	DETAILS_ERP_ORDERS_LINES_FIELD_QUANTITY: 'Quantità',
	DETAILS_ERP_ORDERS_LINES_FIELD_MEASURE_UNIT: 'Unità di misura',
	DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_EXCL: 'Totale (tasse escluse)',
	DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_INCL: 'Totale (tasse incluse)',
	// #endregion

	// #region Details Billing Company section
	DETAILS_BILLING_COMPANY_SECTION: 'Indirizzo di fatturazione',
	DETAILS_BILLING_COMPANY_SUBHEADER: "Visualizza l'indirizzo di fatturazione",
	// #endregion

	// #region Details Shipping Company section
	DETAILS_SHIPPING_ADDRESS_SECTION: 'Indirizzo di spedizione',
	DETAILS_SHIPPING_ADDRESS_SUBHEADER: "Visualizza e modifica l'indirizzo di spedizione"
	// #endregion
};

export default locale;
